import splitStringIntoWords from "utils/StringHelper/splitStringIntoWords";
import {BackgroundProcessResource} from "client/resources/backgroundProcessResource";

export function getProcessDescription(processId: string, processes: BackgroundProcessResource[]) {
    const process = processes.filter(p => p.Id === processId)[0];
    return process && process.Description || splitStringIntoWords(processId);
}